export const HOSPITALISATION_STATUS = [
  {
    label: 'Currently hospitalised',
    value: 'Currently hospitalised'
  },
  {
    label: 'Does not require hospitalisation',
    value: 'Does not require hospitalisation'
  },
  {
    label: 'Recently discharged from the hospital',
    value: 'Recently discharged from the hospital'
  },
  {
    label: 'Will be hospitalised soon',
    value: 'Will be hospitalised soon'
  }
];
